import { render, staticRenderFns } from "./PsMusicView.vue?vue&type=template&id=4049cf0b&scoped=true&"
import script from "./PsMusicView.vue?vue&type=script&lang=js&"
export * from "./PsMusicView.vue?vue&type=script&lang=js&"
import style0 from "./PsMusicView.vue?vue&type=style&index=0&id=4049cf0b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4049cf0b",
  null
  
)

export default component.exports